.configProfilesSidebar {
  grid-column: 1;
  grid-row: 2;
  display: flex;
  width: 392px;
  height: calc(var(--content-height) - 64px);
  padding: var(--spacing-16) var(--spacing-24);
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  .configProfilesHeader {
    display: flex;
    height: 64px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: var(--spacing-04);
    flex-shrink: 0;
    align-self: stretch;
  }

  .configProfilesContent {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: var(--spacing-16);
    width: 100%;
    height: calc(100% - 64px);

    .geoConfigProfiles {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: var(--spacing-08);
      overflow: auto;

      .accordionProfiles {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-04);
        width: 100%;
        padding: var(--spacing-08) 0;
        max-height: 250px;
        overflow: auto;
      }

      .iconClassName {
        background-color: var(--sparky-grey-400);
      }
    }

    .createNewProfileButton {
      width: 100%;
    }
  }
}
